import React, { useEffect, useRef, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import "./css/Insights.css";
import banner from "../../assets/imgs/insight-banner.webp";
import { useLocation } from "react-router";
import Blogs from "./Blogs/Blogs";
import Webinar from "./Webinar/Webinar";
import CaseStudy from "./CaseStudy/CaseStudy";
import Videos from "./Videos/Videos";
import { Helmet } from "react-helmet";

const Insights = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("blogs");
  const [seoInfo, setSEOInfo] = useState({
    title: "Insights - Nonprofit Solution Blogs, Case Study and Webinars",
    keywords: "",
    description:
      "Read all about Nonprofit CRM, Fundraising, Grant Management Solutions, Donation, and Volunteer Management. Learn about new and major updates for Nonprofit Solution in our webinars.",
  });
  //const { pathname } = location;

  // useEffect(() => {
  //     let activeKey = pathname.split('/')[2];
  //     setActiveTab(activeKey);
  //     switch (activeKey) {
  //         case "blogs":
  //             setSEOInfo({
  //                 title: 'Insights - blog',
  //                 keywords: '',
  //                 description: 'Blog page'
  //             });
  //             break;
  //         case "webinar":
  //             setSEOInfo({
  //                 title: 'Insights - Webinars',
  //                 keywords: '',
  //                 description: 'Webinars page'
  //             });
  //             break;
  //         case "video":
  //             setSEOInfo({
  //                 title: 'Insights - Videos',
  //                 keywords: '',
  //                 description: 'Videos page'
  //             });
  //             break;
  //         case "case-study":
  //             setSEOInfo({
  //                 title: 'Insights - Case Studies',
  //                 keywords: '',
  //                 description: 'Case studies page'
  //             });
  //             break;
  //         default:
  //             setSEOInfo({
  //                 title: 'Insights',
  //                 keywords: '',
  //                 description: 'Insights page'
  //             })
  //             break;
  //     }
  // }, [pathname]);

  useEffect(() => {
    const violation = document.getElementById("top-menu");
    window.scrollTo({
      top: violation.offsetTop,
      // behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{seoInfo.title}</title>
        <meta name="keywords" content={seoInfo.keywords} />
        <meta name="description" content={seoInfo.description} />
      </Helmet>
      <div>
        <section>
          <div className="contact-banner">
            <h1 className="headingOne head-one-cc">Insight</h1>
            <div className="innerPage-banner-img">
              <img
                src={banner}
                alt="nonprofit fundraising solutions"
                width="1600"
                height="447"
              />
            </div>
          </div>
        </section>
        <section className="contact_usSection insights-contact-cc">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="insightTabbar">
                  <Tabs
                    id="insights-tabs"
                    activeKey={activeTab}
                    onSelect={(k) => setActiveTab(k)}
                    className="mb-3"
                  >
                    <Tab eventKey="blogs" className="pt-3" title="Blogs">
                      <Blogs />
                    </Tab>
                    <Tab eventKey="webinar" className="pt-3" title="Webinars">
                      <Webinar />
                    </Tab>
                    <Tab eventKey="video" className="pt-3" title="Videos">
                      <Videos />
                    </Tab>
                    <Tab
                      eventKey="case-study"
                      className="pt-3"
                      title="Case Studies & eBook"
                    >
                      <CaseStudy />
                    </Tab>
                  </Tabs>

                  {/* <nav>
                                <div className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
                                    <button className="nav-link" id="nav-blog-tab" ref={blogRef} data-bs-toggle="tab" data-bs-target="#nav-blog" type="button" role="tab"
                                        aria-controls="nav-home">Blogs</button>
                                    <button className="nav-link" id="nav-ebook-tab" ref={ebookRef} data-bs-toggle="tab" data-bs-target="#nav-ebook" type="button" role="tab" aria-controls="nav-profile"
                                    >eBook</button>
                                    <button className="nav-link" id="nav-webinar-tab" ref={webinarRef} data-bs-toggle="tab" data-bs-target="#nav-webinar" type="button" role="tab"
                                        aria-controls="nav-contact">Webinars</button>
                                    <button className="nav-link" id="nav-video-tab" ref={videoRef} data-bs-toggle="tab" data-bs-target="#nav-video" type="button" role="tab" 
                                        aria-controls="nav-contact" >Videos</button>
                                    <button className="nav-link" id="nav-caseStudy-tab" ref={caseStudyRef} data-bs-toggle="tab" data-bs-target="#nav-casestudy" type="button" role="tab"
                                        aria-controls="nav-contact">Case Studies</button>
                                </div>
                            </nav>
                            <div className="tab-content pt-3" id="nav-tabContent">
                                <div className="tab-pane fade active show" id="nav-blog" role="tabpanel" aria-labelledby="nav-blog-tab">

                                    <div className="row">
                                        <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                                            <div className="card tabCards">
                                                <div className="card-body">
                                                    <h5 className="card-title blueTxt">Fundraising</h5>
                                                    <p className="card-text">Your Absolute Guide to Nonprofit Fundraising Success</p>
                                                    <a href="/blog/nonprofit-fundraising" className="card-link"><span className="icon-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="tab-pane fade" id="nav-ebook" role="tabpanel" aria-labelledby="nav-ebook-tab">
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                                            <div className="card tabCards">
                                                <div className="card-body">
                                                    <h5 className="card-title blueTxt">eBook</h5>
                                                    <p className="card-text">Lorem ipsum dolor sit amet lorem dameconsectetur
                                                        adipiscing elit, sed do eiusmod tempor incididun ut labore</p>
                                                    <a href="#" className="card-link"><span className="icon-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="1000">
                                            <div className="card tabCards">
                                                <div className="card-body">
                                                    <h5 className="card-title blueTxt">eBook</h5>
                                                    <p className="card-text">Lorem ipsum dolor sit amet lorem dameconsectetur
                                                        adipiscing elit, sed do eiusmod tempor incididun ut labore</p>
                                                    <a href="#" className="card-link"><span className="icon-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="1500">
                                            <div className="card tabCards">
                                                <div className="card-body">
                                                    <h5 className="card-title blueTxt">eBook</h5>
                                                    <p className="card-text">Lorem ipsum dolor sit amet lorem dameconsectetur
                                                        adipiscing elit, sed do eiusmod tempor incididun ut labore</p>
                                                    <a href="#" className="card-link"><span className="icon-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="nav-webinar" role="tabpanel" aria-labelledby="nav-webinar-tab">
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                                            <div className="card tabCards">
                                                <div className="card-body">
                                                    <h5 className="card-title blueTxt">Get the Right Nonprofit Technology Solution for the Right Cause</h5>
                                                    <p className="card-text">From small community initiatives to large-scale charities, every nonprofit needs the right technology solution to remain competitive, streamline fundraising efforts, and optimize its program delivery needs.</p>
                                                    <a href="https://www.beyondkey.com/on-demand-webinar-on-right-cause-nonprofit-solution" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="nav-video" role="tabpanel" aria-labelledby="nav-video-tab">
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                                            <div className="card tabCards">
                                                <div className="card-body">
                                                    <h5 className="card-title blueTxt">Right Cause Nonprofit Solution</h5>
                                                    <p className="card-text">Automate day-to-day processes to foster donor relationships, track and manage Fundraising Activities, Grant Management, Program Delivery, Volunteer Management and Reporting.</p>
                                                    <a href="https://youtu.be/j8g5v9GpakQ" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="1000">
                                            <div className="card tabCards">
                                                <div className="card-body">
                                                    <h5 className="card-title blueTxt">Right Cause Grant Management Solution</h5>
                                                    <p className="card-text">A comprehensive Grants Management Solution built on secure Microsoft Dynamics 365 platform.</p>
                                                    <a href="https://youtu.be/Yby8S1ytbd4" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div className="tab-pane fade" id="nav-casestudy" role="tabpanel" aria-labelledby="nav-caseStudy-tab">
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                                            <div className="card tabCards">
                                                <div className="card-body">
                                                    <h5 className="card-title blueTxt">Case study</h5>
                                                    <p className="card-text">How Right Cause Leveraged Power Platform to Build a Scalable and Patient-Centric Portal for A Leading Healthcare Services Client</p>
                                                    <a href="../../assets/downloads/Case-Study/Prodigy.pdf" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="1000">
                                            <div className="card tabCards">
                                                <div className="card-body">
                                                    <h5 className="card-title blueTxt">Case study</h5>
                                                    <p className="card-text">Digital Transformation via the Power Portal Platform Saves Time and Unlocks Insights for Leading Healthcare Non-Profit</p>
                                                    <a href="../../assets/downloads/Case-Study/KHA.pdf" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Insights;
